import React from "react";
import { Modal } from 'react-bootstrap';
import { titleName } from "../../../utils/namings-classnames";

export default function Event({ data, close }) {
    const platformName = titleName(data.platform);
    const rawPlat = (data.platform || '').toLowerCase();
    const isClientBlock =
        ['Blocage client', 'Planning Manager (Blocking Zone)'].includes(data.platform) ||
        platformName === 'Blocage client' ||
        rawPlat === 'unavailable' ||
        rawPlat === 'rent-client' ||
        rawPlat === 'block-unavailable';

    const getBadgeClass = () => {
        const name = platformName.toLowerCase();
        if (name.includes('airbnb')) return 'badge-airbnb';
        if (name.includes('booking')) return 'badge-booking';
        if (name.includes('homeaway')) return 'badge-homeaway';
        if (name.includes('mypacome')) return 'badge-mypacome';
        if (name.includes('gites')) return 'badge-gites';
        if (name.includes('indisponibilité')) return 'badge-unavailable';
        return 'badge-client';
    };

    return (
        <Modal show={!!data.dates?.start} onHide={close} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                        <span className={`badge ${getBadgeClass()}`}>
                            {platformName}
                        </span>
                        <span>Détails de la réservation</span>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="event-details">
                    {/* Dates */}
                    <div className="event-detail-row">
                        <div className="event-detail-icon">
                            <i className="fas fa-calendar-alt" />
                        </div>
                        <div className="event-detail-content">
                            <span className="event-detail-label">Période</span>
                            <span className="event-detail-value">
                                Du {formatDate(data.dates.start)} au {formatDate(data.dates.end)}
                            </span>
                        </div>
                    </div>

                    {/* Duration */}
                    <div className="event-detail-row">
                        <div className="event-detail-icon">
                            <i className="fas fa-clock" />
                        </div>
                        <div className="event-detail-content">
                            <span className="event-detail-label">Durée</span>
                            <span className="event-detail-value">
                                {calculateDuration(data.dates.start, data.dates.end)}
                            </span>
                        </div>
                    </div>

                    {/* Guest Info (if not a client block) */}
                    {!isClientBlock && (
                        <>
                            {data.adults > 0 && (
                                <div className="event-detail-row">
                                    <div className="event-detail-icon">
                                        <i className="fas fa-users" />
                                    </div>
                                    <div className="event-detail-content">
                                        <span className="event-detail-label">Adultes</span>
                                        <span className="event-detail-value">{data.adults}</span>
                                    </div>
                                </div>
                            )}

                            {data.kids > 0 && (
                                <div className="event-detail-row">
                                    <div className="event-detail-icon">
                                        <i className="fas fa-child" />
                                    </div>
                                    <div className="event-detail-content">
                                        <span className="event-detail-label">Enfants</span>
                                        <span className="event-detail-value">{data.kids}</span>
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={close}>
                    Fermer
                </button>
            </Modal.Footer>

            <style>{`
                .event-details {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
                
                .event-detail-row {
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                    padding: 12px;
                    background: #f8f9fa;
                    border-radius: 12px;
                }
                
                .event-detail-icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: white;
                    border-radius: 10px;
                    color: #003952;
                    flex-shrink: 0;
                }
                
                .event-detail-content {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                }
                
                .event-detail-label {
                    font-size: 0.75rem;
                    font-weight: 600;
                    color: #71717a;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                
                .event-detail-value {
                    font-size: 0.95rem;
                    color: #18181b;
                    font-weight: 500;
                }

                .modal-footer .btn-secondary {
                    background: #f4f4f5;
                    border: none;
                    color: #3f3f46;
                    border-radius: 12px;
                    padding: 10px 24px;
                    font-weight: 500;
                }

                .modal-footer .btn-secondary:hover {
                    background: #e4e4e7;
                }
            `}</style>
        </Modal>
    );
}

function formatDate(date) {
    return new Date(date).toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}

function calculateDuration(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) return '1 nuit';
    return `${diffDays} nuits`;
}
